import { ActionFactory } from '@/components/utils';
import { CandidateTab } from '@/pages/Candidate/hooks/useCandidateTabs/types';

export const Actions = ActionFactory({
  edit: true,
  delete: false,
  editStatus: true,
  resumeChecks: true,
  setPending: true,
  refresh: false,
});

export const path = (path: CandidateTab) => path;
